import Model from '/lib/model'

export default \
class Plan extends Model
  @className: 'Plan'

